export default "__VITE_ASSET__1a2b81f7__"